import _ from 'underscore';

export const watchResize = () => {
    const setProperty = () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    };
    window.addEventListener('resize', _.throttle(setProperty, 1000));
    setProperty();
};
